#import "../fragments/saved-list-stub-fragment.graphql"

mutation UpdateSavedFilter($input: FilterUpdateInput!) {
    filterUpdate(input: $input) {
        filter {
            ...SavedListStubFragment
            isUpdateable
            isImmutable
            creatorUser {
                name
                id
            }
        }
    }
}
